import { MutableValue } from "@/modules/api/mutable-value.interface";

export default class PlushieArbitraryAttribute implements MutableValue {
  public isNew = true;

  private fCreatedAt?: Date;

  constructor(
    private fId: string,
    private fPlushie: string,
    private fName: string,
    private fValue: string
  ) {
    [fId, fPlushie, fName, fValue].forEach((arg, index) => {
      if (arg === undefined) {
        throw new Error(`Undefined value passed at position: ${index}`);
      }
    });
  }

  get id(): string {
    return this.fId;
  }

  get createdAt(): Date | undefined {
    return this.fCreatedAt;
  }

  get plushie(): string {
    return this.fPlushie;
  }

  get name(): string {
    return this.fName;
  }

  get value(): string {
    return this.fValue;
  }
}
